import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

// Register locale data for date formatting
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');

if(environment.enableSentry) {
  Sentry.init({
    dsn: environment.sentryDsn,
    sendDefaultPii: false
  });
}


bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
